import React from 'react';
import { LandingFlorida } from './pages/LandingFlorida';
export function App() {
  return <LandingFlorida data-id="element-0" data-mp="35ckaa75id2iz" />;
}